<template>
  <div
    class="flex"
    @click="onUndoButtonClicked()"
    v-aha-emit-action
  >
    <aha-button variant="base" :buttonIcon="buttonIcon" :submitting="isRestoringOriginalSlide">
      {{ $i18nPresenter.t('Undo') }}
    </aha-button>
  </div>
</template>

<script>
export default {
  props: {
    isRestoringOriginalSlide: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    buttonIcon() {
      return {
        name: 'undo',
        width: 16,
        height: 16,
        viewBox: '0 0 16 16',
      }
    },
  },

  methods: {
    onUndoButtonClicked() {
      this.$emit('onUndoButtonClicked')
    },
  },
}
</script>
